import useBusinessTypes from "../../../../hooks/useBusinessTypes";
import useUserPositions from "../../../../hooks/useUserPositions";
import styles from "./PreviewBusiness.module.scss";

interface PreviewItemProps {
  label: string;
  value: string;
}

const PreviewItem = ({ label, value }: PreviewItemProps) => (
  <div className={styles.previewItem}>
    <p className={styles.label}>{label}</p>
    <p className={styles.value}>{value}</p>
  </div>
);

interface IPreviewBusiness {
  formData: any;
  onComplete: (data?: any) => void;
  isSubmitting?: boolean;
}

const PreviewBusiness: React.FC<IPreviewBusiness> = ({
  formData,
  onComplete,
  isSubmitting = false,
}) => {
  const { data: businessTypes } = useBusinessTypes();
  const { data: userPositions } = useUserPositions();

  const handleProceed = () => {
    onComplete(formData);
  };

  const getBusinessTypeName = () => {
    return (
      businessTypes?.data?.find(
        (_businessType: any) =>
          String(_businessType.id) === String(formData.customerSubType)
      )?.name || ""
    );
  };

  const getUserPositionName = () => {
    return (
      userPositions?.data?.find(
        (position: any) => String(position.id) === String(formData.userPosition)
      )?.name || ""
    );
  };

  return (
    <div className={styles.previewContainer}>
      <p className={styles.subtitle}>
        Review your details to ensure everything is correct before submitting
      </p>

      <div className={styles.previewGrid}>
        <PreviewItem label="Business Type" value={getBusinessTypeName()} />
        <PreviewItem
          label="Business Name"
          value={formData.businessName || ""}
        />
        <PreviewItem
          label="RC Number"
          value={formData.businessRegistrationNumber || ""}
        />
        <PreviewItem label="Position" value={getUserPositionName()} />
        <PreviewItem label="Email Address" value={formData.email || ""} />
        <PreviewItem label="Phone Number" value={formData.phoneNumber || ""} />
        <PreviewItem label="First Name" value={formData.firstname || ""} />
        <PreviewItem label="Last Name" value={formData.lastname || ""} />
        <PreviewItem
          label="Country"
          value={formData.countryCode === "NG" ? "Nigeria" : "NG"}
        />
        <PreviewItem label="Effective Date" value={formData.effectiveDate} />
      </div>

      <div className={styles.actionButtonContainer}>
        <button
          type="button"
          onClick={handleProceed}
          className="btn advancly-btn btn-lg btn-block"
          disabled={isSubmitting}
        >
          {isSubmitting ? "Creating Account..." : "Proceed"}
        </button>
      </div>
    </div>
  );
};

export default PreviewBusiness;
